import { render } from "./DetailProjectView.vue?vue&type=template&id=929c55c8"
import script from "./DetailProjectView.vue?vue&type=script&lang=js"
export * from "./DetailProjectView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__